<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="imgstyle">
      <div v-if="showVideo()" class="music-container">
        <!-- <el-tooltip :content="musicName" placement="top-start">
          <span class="music-name">{{ musicName }}</span>
        </el-tooltip> -->
        <!-- <el-tooltip
          v-if="playing"
          :content="tooltipForPause"
          placement="top-start"
        >
          <i class="el-icon-video-pause el-icon-action" @click="handlePause" />
        </el-tooltip>-->

        <span style="margin-right: 20px" @click="handlePlay" class="preview">
          <b>预览</b>
          <i class="el-icon-video-play el-icon-action" />
        </span>

        <span @click="handleDelete" class="preview" v-if="isedite">
          <i class="el-icon-delete el-icon-action" />
          <b>删除</b>
        </span>
      </div>
      <el-tooltip
        v-else-if="isedite"
        popper-class="image-tip"
        :disabled="disabledTooltip() || !isedite"
        :content="tooltip"
        placement="top-start"
      >
        <el-upload
          class="upload-btn"
          list-type="text"
          :show-file-list="false"
          :disabled="!isedite || videoloading"
          accept="video/*"
          :before-upload="handleBeforeUpload"
          ref="uploader"
          action="#"
        >
          <!-- <i class="el-icon-plus"></i> -->
          <div class="icon-wrap-container">
            <div v-if="videoloading" class="inpro">
              <el-progress
                :percentage="progress"
                :stroke-width="22"
                :text-inside="true"
                style="width: 100%"
              ></el-progress>
              <el-button size="mini" type="danger" @click="handelstop"
                >取消</el-button
              >
            </div>
            <i class="el-icon-plus uploader-icon" v-else />
          </div>
        </el-upload>
      </el-tooltip>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <video :src="src" controls style="width: 100%"></video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handelclose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Validator from '../../utils/validator'
import PageModel from '../../models/page'

// ===== 可配置项 =====
const CONFIG = {
  baseURL: '', // API 基础路径;同源留空,跨域填后端地址如 'http://reg.justtool.com'
  partSize: 50 * 1024 * 1024, // 每段 5MB(OBS 多段上传最小段大小,最后一段可更小)
  concurrency: 1, // 并发上传段数(浏览器同源默认6连接,留余量给其他请求)
  maxRetry: 3 // 单段失败重试次数
}
export default {
  name: 'jtBigVideo',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: '30%'
    },
    src: {
      type: String,
      default: ''
    },
    videoName: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '30px'
    },
    uploadAction: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    supportTypes: {
      type: Array,
      default: () => ['video/mp4', 'video/quicktime']
    },
    supportSize: {
      type: Array,
      default: []
    },
    editable: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    alwaysEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%'
      },
      imgstyle: {
        width: window.innerWidth > 768 ? '500px' : '100%'
      },
      videoFrameStyle: {
        width: this.width,
        height: this.height
      },
      uploadStyle: {
        width: this.width,
        height: this.height
      },
      tooltipForPause: this.$t('video.PAUSE'),
      tooltipForPlay: this.$t('video.PLAY'),
      tooltipForDelete: this.$t('video.DELETE'),
      playing: false,
      audio: null,
      videoloading: false,
      progress: 0,
      dialogVisible: false,
      ctx: {}
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    }
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    showVideo() {
      return !_.isEmpty(this.src)
    },
    // newuploadAction() {
    //   let newaction = 'http://upload.justtool.com' + this.uploadAction
    //   return newaction
    // },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    handleEndedEvent() {
      this.playing = false
    },
    handlProgress(event, file) {
      this.progress = parseInt(file.percentage)
    },
    handelerr(err, file) {
      this.$message.error('上传失败')
      this.videoloading = false
      this.progress = 0
    },

    handlePlay() {
      this.dialogVisible = true
    },
    handelclose() {
      this.dialogVisible = false
    },
    async handelstop() {
      // this.$refs.uploader.abort()
      // setTimeout(() => {
      //   this.progress = 0
      //   this.videoloading = false
      // }, 500)
      if (this.ctx.objectKey && this.ctx.uploadId) {
        await this.abortUpload(this.ctx.objectKey, this.ctx.uploadId)
      }
    },

    handleDelete() {
      const msg = this.$t('image.CONFIRM_FOR_DELETE')
      const title = this.$t('global.TIPS')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
        cancelButtonText: this.$t('page.SUBMIT_CONFIRM_CANCEL')
      })
        .then(() => {
          this.$emit('delete')
          this.videoloading = false
          this.progress = 0
        })
        .catch(() => {})
    },
    handleUploadSuccess(url) {
      this.$emit('success', { url })
      this.videoloading = false
    },

    async handleBeforeUpload(file) {
      try {
        this._validate(file)
        this.videoloading = true
        const { fileId } = await this.uploadLargeVideo(file, {
          onProgress: p => {
            this.progress = p
          },
          onComplete: ({ url }) => this.handleUploadSuccess(url),
          getContext: c => {
            this.ctx = c
          } // 拿到 objectKey/uploadId 供取消用
        })
        console.log('fileId(回写业务用):', fileId)
        return false
      } catch (err) {
        const title = this.$t('global.ERROR')
        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false
        })
        throw err
      } finally {
        this.videoloading = false
      }
    },
    _validate(file) {
      let errMsg = this.$t('video.SUPPORT_VIDEO_TYPE', {
        videoType: _.join(this.supportTypes)
      })
      Validator.isSupportFileType(file.type, this.supportTypes, errMsg)
      let errMsg1 = this.$t('video.SUPPORT_VIDEO_SIZE', {
        videoSize:
          this.supportSize.length === 2
            ? this.supportSize[1] / 1024 / 1024
            : this.supportSize[0] / 1024 / 1024
      })
      let errMsg2 = this.$t('video.MIN_VIDEO_SIZE', {
        videoSize: this.supportSize[0] / 1024 / 1024
      })
      Validator.isSupportFileSize(file.size, this.supportSize, errMsg1, errMsg2)
    },

    async uploadLargeVideo(file, opts = {}) {
      const {
        onProgress = () => {},
        onComplete,
        onError,
        shouldAbort = () => false
      } = opts
      let uploadedBytes = 0
      let aborted = false
      let completed = false // 合并是否成功(成功后回调出错不再 abort,避免误删已合并文件)
      const ctx = { objectKey: null, uploadId: null }
      opts.getContext && opts.getContext(ctx)

      try {
        // 1. 初始化:向后端要 objectKey + uploadId
        const initResp = await PageModel.uploadInit({
          mimeType: file.type || 'video/mp4',
          size: file.size
        })
        ctx.objectKey = initResp.payload.objectKey
        ctx.uploadId = initResp.payload.uploadId
        const { objectKey, uploadId } = ctx
        const partCount = Math.ceil(file.size / CONFIG.partSize)
        const parts = [] // [{partNumber, etag}] 供合并使用
        const queue = this.makeQueue(partCount) // 待上传段号 [1,2,...,N]

        // 2. 分段并发上传
        const worker = async () => {
          while (queue.length && !aborted) {
            if (shouldAbort()) {
              aborted = true
              break
            }
            const partNumber = queue.shift()
            const start = (partNumber - 1) * CONFIG.partSize
            const end = Math.min(start + CONFIG.partSize, file.size)
            const blob = file.slice(start, end)

            // 带重试的上传单段
            let etag = null
            for (
              let attempt = 1;
              attempt <= CONFIG.maxRetry && !aborted;
              attempt++
            ) {
              try {
                etag = await this.uploadOnePart(
                  objectKey,
                  uploadId,
                  partNumber,
                  blob,
                  loaded => {
                    // 实时进度:已完成的段 + 本段已传
                    onProgress(
                      +(((uploadedBytes + loaded) / file.size) * 100).toFixed(1)
                    )
                  }
                )
                break
              } catch (err) {
                if (attempt === CONFIG.maxRetry) {
                  throw new Error(
                    `段 ${partNumber} 上传失败(${CONFIG.maxRetry}次重试后放弃): ${err.message}`
                  )
                }
                console.warn(
                  `段 ${partNumber} 第 ${attempt} 次失败,重试...`,
                  err.message
                )
                await this.delay(500 * attempt) // 指数退避
              }
            }
            if (aborted) break
            parts.push({ partNumber, etag })
            uploadedBytes += end - start // 本段完成,累加
            onProgress(+((uploadedBytes / file.size) * 100).toFixed(1))
          }
        }

        // 启动并发池
        await Promise.all(Array.from({ length: CONFIG.concurrency }, worker))

        if (aborted) {
          // 通知后端清理已传分段
          await this.abortUpload(objectKey, uploadId).catch(() => {})
          onError && onError(new Error('用户取消上传'))
          return
        }

        // 3. 合并
        const completeResp = await PageModel.uploadComplete(this.uploadAction, {
          objectKey,
          uploadId,
          parts
        })
        completed = true // 合并成功,后续回调若出错不再 abort,避免误删已合并文件
        onProgress(100)
        onComplete && onComplete(completeResp.payload)
        return completeResp.payload // { fileId, url }
      } catch (err) {
        aborted = true
        // 出错也尝试清理,避免残留分段产生存储费用
        if (!completed && ctx.objectKey && ctx.uploadId) {
          await this.abortUpload(ctx.objectKey, ctx.uploadId).catch(() => {})
        }
        onError ? onError(err) : console.error('上传失败:', err)
        throw err
      }
    },
    /**
     * 上传单个分段:先向后端拿签名URL,再 PUT 到 OBS
     * @returns {Promise<string>} 该段的 ETag(含双引号,保持 OBS 返回原样)
     */
    async uploadOnePart(objectKey, uploadId, partNumber, blob, onProgress) {
      // 2a. 向后端申请本段的预签名 URL
      const signResp = await PageModel.uploadSign(
        encodeURIComponent(objectKey),
        encodeURIComponent(uploadId),
        partNumber
      )
      const signedUrl = signResp.payload.url

      // 2b. 直接 PUT 到 OBS(带进度,返回 ETag)
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('PUT', signedUrl, true)
        xhr.setRequestHeader('Content-Type', 'application/octet-stream')
        xhr.upload.onprogress = e => onProgress && onProgress(e.loaded)
        xhr.onload = () => {
          if (xhr.status < 300) {
            // ETag 保持 OBS 返回原样(含双引号),后端 complete 需要带引号
            const etag =
              xhr.getResponseHeader('ETag') || xhr.getResponseHeader('etag')
            if (etag) resolve(etag)
            else
              reject(
                new Error(
                  '未取到 ETag(请检查 OBS 桶 CORS 的 ExposeHeader 是否包含 ETag)'
                )
              )
          } else {
            reject(new Error(`OBS 返回 ${xhr.status}`))
          }
        }
        xhr.onerror = () => reject(new Error('网络错误'))
        xhr.send(blob)
      })
    },
    /**
     * 取消上传:通知后端 abort,删除 OBS 上已传的段
     */
    async abortUpload(objectKey, uploadId) {
      try {
        const r = await PageModel.cancelUpload({ objectKey, uploadId })
        const j = await r.json()
        return j.errNo === 0
      } catch (e) {
        return false
      }
    },

    // ===== 工具函数 =====
    makeQueue(n) {
      return Array.from({ length: n }, (_, i) => i + 1)
    },
    delay(ms) {
      return new Promise(r => setTimeout(r, ms))
    }
  }
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.music-container {
  // border: 1px dashed #333;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #b4ff8f;
}

.music-name {
  width: 70%;
}

.el-icon-action {
  color: black;
  cursor: pointer;
}

.upload-btn {
  padding: 5px;
  // width: 100%;
  border: 1px dashed #333;
}

.upload-btn >>>.el-upload {
  display: block;
}

.icon-wrap-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.uploader-icon {
  font-size: 28px;
  color: #333;
  cursor: pointer;
}

.image-tip {
  max-width: 200px;
}

.src {
  color: #5daf34;
  margin-right: 20px;

  sub {
    color: #505050;
  }
}

.component-container >>> .el-dialog {
  max-width: 600px;
}

.el-icon-action {
  font-size: 30px;
}

.inpro {
  display: flex;
  width: 100%;
}

.preview {
  display: flex;
  align-items: center;
}
</style>
